<template>
	<div class="generalInfo" :class="{ 'onlyView': getPermissionAction }">
		<div class="customerInfo">
			<div class="customerInfoTitle">Customer info</div>
			<field
					:class-error="valid.zelle_id && valid.zelle_id.$error"
					margin="0 0 10px 0"
					label="Payments account"
					placeholder="Select payments account"
					@updateSelect="onSelect"
					:autocompleteValue="zelle_id"
					:items="zelleAccount"
					:isClearable="false"
					item-text="name"
					is-select
					is-required
			></field>
			<field
					width="290px"
					margin="0 0 10px 0"
					label="MC"
					placeholder="Enter MC number"
					@updateInput="onInput($event, 'mc')"
					:setInputValue="mc"
			></field>
			<field
					margin="0 0 10px 0"
					width="290px"
					label="DOT"
					placeholder="Enter DOT number"
					@updateInput="onInput($event, 'dot')"
					:setInputValue="dot"
			></field>
			<field
					margin="0 0 10px 0"
					width="290px"
					label="Federal ID"
					placeholder="Enter federal ID number"
					@updateInput="onInput($event, 'federal')"
					:setInputValue="federal"
			></field>
			<field
					margin="0 0 10px 0"
					width="290px"
					label="PDF address"
					placeholder="Enter PDF address"
					@updateInput="onInput($event, 'pdf_address')"
					:setInputValue="pdf_address"
			></field>
			<field
					margin="0 0 10px 0"
					width="290px"
					label="Physical address"
					placeholder="Enter phisical address"
					@updateInput="onInput($event, 'phisical_address')"
					:setInputValue="phisical_address"
					isTextarea
			></field>
			<field
					margin="0"
					width="290px"
					label="Mailing address"
					placeholder="Enter mailing address"
					@updateInput="onInput($event, 'mailing_address')"
					:setInputValue="mailing_address"
					isTextarea
			></field>
		</div>
		<div v-if="!isCustomers" class="customInfoRight">
			<div>
				<customer-list
						:valid="valid"
						:select_companies_list="select_companies_list"
						:subcompanies="subcompanies"
						:subcompanies_type="subcompanies_type"
						:subcompanies_name="subcompanies_name"
						:subcompanies_status="subcompanies_status"
						@updateSubcompaniesType="onSubcompaniesType"
						@updateSubcompaniesList="onSubcompaniesList"
						@updateSubcompaniesDelete="onSubcompaniesDelete"
				></customer-list>

				<div v-if="findUs && findUs.length" style="margin-top: 20px;" class="groupField">
					<v-radio-group :disabled="siDisabledFindUs" @change="onRadio" v-model="find_us_id">
						<template v-slot:label>
							<div :class="{'error_text': valid['find_us_id'] && valid['find_us_id']?.$error}">How did they find us:</div>
						</template>
						<v-radio :key="item.id" v-for="item in findUs" :label="item.name" :value="item.id"></v-radio>
					</v-radio-group>
				</div>
			</div>

			<div class="paymentNames">
				<div class="paymentNames__header">
					<div class="paymentNames__title">
						Payment name
					</div>

					<v-btn
							v-if="!getPermissionAction"
							type="button"
							depressed
							class="mainBtn mainBtn-text"
							@click="onAddPayment"
					>
      <span class="btnIco">
        <svg-sprite
		        icon-id="addItem"
		        width="20"
		        height="20"
        ></svg-sprite>
      </span>

						<span class="btnText">
        Add name
      </span>
					</v-btn>
				</div>

				<div
						v-for="(paymentName, idx) in payment_names"
						:key="idx"
						class="paymentNames__item"
				>
					<field
							width="290px"
							margin="0"
							label="Payment name"
							placeholder="Enter payment name"
							:setInputValue="paymentName"
							@updateInput="onPaymentInput($event, idx)"
					></field>

					<button
							v-if="!getPermissionAction"
							type="button"
							class="deleteItem"
							@click="onDeletePayment(idx)"
					>
						<svg-sprite
								style="color: #19BC38"
								width="20"
								height="20"
								icon-id="deleteItem"
						></svg-sprite>
					</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerList from "@/components/Maintenance/Customer/CustomerForm/FirstTab/CustomerList/CustomerList";
// helper
import getDefaultDate from "@/helper/getDefaultDate";

export default {
	name: "FirstTab",
	components: {
		CustomerList
	},
	props: {
		valid: Object,
		siDisabledFindUs: Boolean,
		subcompanies: Array,
		select_companies_list: Array,
		subcompanies_type: Boolean,
		isCustomers: Boolean,
		subcompanies_name: String,
		subcompanies_status: Boolean,
		getPermissionAction: Boolean
	},
	computed: mapGetters([ 'customersList', 'findUs' ]),
	data: () => ({
		dateF: getDefaultDate(),
		creator: null,
		mc: "",
		dot: "",
		federal: "",
		pdf_address: "",
		phisical_address: "",
		zelle_id: null,
		zelleAccount: [],
		mailing_address: "",
		created_at: null,
		find_us_id: null,
		payment_names: [],
	}),
	methods: {
		/**
		 * Add payment name field.
		 *
		 * @returns {void}
		 */
		onAddPayment() {
			this.payment_names.push("");
			this.getData();
		},

		/**
		 * Update payment name.
		 *
		 * @param {Object} event Field event.
		 * @param {number} idx Payment index.
		 * @returns {void}
		 */
		onPaymentInput({ value }, idx) {
			this.$set(this.payment_names, idx, value);
			this.getData();
		},

		/**
		 * Delete payment name.
		 *
		 * @param {number} idx Payment index.
		 * @returns {void}
		 */
		onDeletePayment(idx) {
			this.payment_names.splice(idx, 1);
			this.getData();
		},

		onSelect({ value }) {
			this.zelle_id = value?.id ?? value;
			this.getData();
		},
		getData() {
			this.$emit('updateData', { ...this.$data });
		},
		onInput({ value }, key) {
			this[key] = value;
			this.getData();
		},
		onRadio() {
			this.getData();
		},
		onSubcompaniesType(value) {
			this.$emit('updateSubcompaniesType', value);
		},
		onSubcompaniesList(values) {
			this.$emit('updateSubcompaniesList', values);
		},
		onSubcompaniesDelete(idx) {
			this.$emit('updateSubcompaniesDelete', idx);
		},
	},
	mounted() {
		const {
			customers,
			zelleAccount,
			payment_names
		} = this.customersList;

		const {
			mc,
			dot,
			federal,
			pdf_address,
			phisical_address,
			mailing_address,
			zelle_id,
			find_us_id,
			creator,
			created_at
		} = customers;

		this.mc = mc;
		this.dot = dot;
		this.federal = federal;
		this.pdf_address = pdf_address;
		this.phisical_address = phisical_address;
		this.mailing_address = mailing_address;
		this.creator = creator;
		this.zelleAccount = zelleAccount;
		this.zelle_id = zelle_id;
		this.find_us_id = find_us_id;
		this.created_at = created_at;

		this.payment_names = Array.isArray(payment_names)
			? payment_names.map((item) => item.name || "")
			: [];

		this.getData();
	}
};
</script>

<style scoped lang="scss">
@import "FirstTab";

.paymentNames {
	margin-top: 20px;

	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 15px;
		margin-bottom: 10px;
	}

	&__title {
		font-size: 16px;
		font-weight: 600;
	}

	&__item {
		display: flex;
		align-items: flex-end;
		gap: 10px;
		margin-bottom: 10px;

		.deleteItem {
			flex: 0 0 auto;
			margin-bottom: 8px;
		}
	}

	@media (max-width: 768px) {
		&__header {
			align-items: flex-start;
			flex-direction: column;
		}

		&__item {
			align-items: stretch;
		}
	}
}
</style>
